<template>
  <AhaContent :scroll-y="false">
    <div class="question-moderation">
      <PresentationInformation />
      <div class="pt-5 flex h-0 flex-grow">
        <span class="statuses__wrapper hidden sm:inline-block">
          <Statuses />
        </span>

        <span class="questions__wrapper">
          <Statuses
            class="sm:hidden"
            variant="row"
          />

          <div class="question__divider sm:hidden" />

          <div class="h-0 flex-grow">
            <Questions />
          </div>
        </span>
      </div>
    </div>
  </AhaContent>
</template>

<script>
import PresentationInformation from '@/components/question-moderation/PresentationInformation.vue'
import Statuses from '@/components/question-moderation/Statuses.vue'
import Questions from '@/components/question-moderation/Questions.vue'

// container
import StatusesContainer from '@/containers/question-moderation/Statuses.ts'
import QuestionsContainer from '@/containers/question-moderation/Questions.ts'
import PresentationInformationContainer from '@/containers/question-moderation/PresentationInformation.ts'

export default {
  components: {
    Questions: QuestionsContainer(Questions),
    Statuses: StatusesContainer(Statuses),
    PresentationInformation: PresentationInformationContainer(PresentationInformation),
  },
}
</script>

<style lang="scss">
.question-moderation {
  @apply px-4 sm:px-8 pt-4 flex flex-col h-full;
}

.statuses__wrapper {
  @apply align-top mr-12;
}

.questions__wrapper {
  @apply inline-flex flex-col flex-grow max-w-full;
}

.question__divider {
  @apply bg-base-30 -mx-8 mb-3;

  opacity: 0.2;
  height: 1px;
  margin-top: -2px;
}
</style>
